var _style, _defs, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st18{fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108992365084776287870000014023710700562006935_",
    d: "M7.7 7.3h85.7V93H7.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110447003140102496790000007973194064317775021_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108992365084776287870000014023710700562006935_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000110447003140102496790000007973194064317775021_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M18.2 34c-8.9 8.9-8.9 23.4 0 32.3l16.2 16.2c8.9 8.9 23.4 8.9 32.3 0l16.2-16.2c8.9-8.9 8.9-23.4 0-32.3L66.7 17.8c-8.9-8.9-23.4-8.9-32.3 0L18.2 34z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.6,
    cy: 49.5,
    r: 14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 74.4,
    cy: 50.1,
    r: 6.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 26.4,
    cy: 50.1,
    r: 6.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreReferral);
export default __webpack_public_path__ + "static/media/exploreReferral.fe84b69e9b4db5f34c40ad9410c84e32.svg";
export { ForwardRef as ReactComponent };